// extracted by mini-css-extract-plugin
module.exports = {"main-component":"addTaskButton_main-component__1x8wB"};